import Reflux from 'reflux'

const ContentStoreActions = Reflux.createActions([
	'getContent',
	'imageLoaded'
]);

export default ContentStoreActions;